export const allComments = () => ({ comments: { comments } }) => comments;
